// Core
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Scss
import "./styles.scss";

//Import assets
import assets from "../../../Assets";

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from "../../Common/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import DropDownBox from "Components/Common/DropDownBox";
import { useDispatch } from "react-redux";
import { fetchFailureAnalysisRequest } from "../../../Redux/Slices/failureAnalysisReqSlice";
import moment from "moment";
import { fetchUserManagementCompany } from "../../../Redux/Slices/userManagementSlice";

const FailureAnalysisRequest = () => {
  const [tableDetails, setTableDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortOptions, setSortOptions] = useState({
    sort_by: true,
    order_by: "updatedAt",
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [company, setCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "Users Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "user_name" })
      },
    },
    {
      label: "Mobile Number",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "mobile_number" })
      },
    },
    {
      label: "Company Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "company_name" })
      },
    },
    {
      label: "Request Submitted on",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "updatedAt" })
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "report_status" })
      },
    },
    {
      label: "Action",
      sortKey: false,
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  function formatSendDate(dateString) {
    if (!dateString) return null; // If date is empty or null, return null

    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    // Prevent sending "1970-01-01"
    return formattedDate === "1970-01-01" ? null : formattedDate;
  }


  useEffect(() => {
    setIsLoading(true)
    getAllFailureRequestData();
  }, [currentPage, sortOptions.sort_by, company, fromDate, toDate]);

  const getAllFailureRequestData = () => {
    dispatch(
      fetchFailureAnalysisRequest({
        data: {
          page: currentPage,
          limit: "10",
          sort_by: sortOptions.sort_by ? "DESC" : "ASC",
          order_by: sortOptions.order_by,
          from_date: formatSendDate(fromDate) || "",
          ...(formatSendDate(toDate) && { to_date: formatSendDate(toDate) }),
          company_id: company?.value,
        },
        callBack: getFailureAnalysisDetails,
      })
    );
  };

  const getFailureAnalysisDetails = (data) => {
    setTableDetails(data?.data?.data_list || []);
    setTotalPage(data?.data?.pageMeta?.totalPages);
    setTotalCount(data?.data?.pageMeta?.total || 0);
    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(
      fetchUserManagementCompany({
        callBack: getCompanyCB,
      })
    );
  }, []);

  const getCompanyCB = (value) => {
    const updatedCategories = value.data.map((item) => ({
      ...item,
      label: item.company_name,
      value: item.company_id,
    }));
    const additionalObject = {
      label: 'All Companies',
      value: '',
      company_name: 'All Companies'
    };
    setCompanyList([additionalObject, ...updatedCategories])
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFromDate = (date) => {
    // if (date) {
    setFromDate(date ? new Date(date) : null);
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
    // } else {
    //   setFromDate(null); 
    // }
  };
  const handleToDate = (date) => {
    setToDate(date ? new Date(date) : null);
  };
  const getInitials = (name) => {
    const [firstName = "", lastName = ""] = name.split(" ");
    return (
      (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase()
    );
  };
  return (
    <div className="failureRequestContainer">
      <div className="failureRequestHeader">
        <p>Failure Analysis Request</p>
        <div className="failureReqDatePicker">
          <p className="totalCount">
            Total count : {totalCount}
          </p>
          <DropDownBox
            placeholder="Company Name"
            options={companyList}
            onChange={(option) => {
              setCompany(option);
              setCurrentPage(1);
            }}
            value={company}
            customStyles={{
              control: (provided) => ({
                ...provided,
                border: '0px',
                borderBottom: '1px solid grey',
                borderRadius: '0',
                width: '180px',
                boxShadow: 'none',
                padding: '5px 3px',
                fontFamily: 'Poppins',
                marginRight: '20px',
                fontSize: '14px',
                height: "50px",
              }),
              menu: (provided) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
              }),
              option: (provided, state) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
                backgroundColor: state.isFocused ? '#f1f1f1' : 'white',
                color: state.isFocused ? 'black' : 'grey',
                cursor: 'pointer',
              }),
            }}
          />
          <DatePicker
            placeholderText="Enter From Date"
            selected={fromDate}
            onChange={handleFromDate}
            format={"dd-MM-yyyy"}
          />
          <DatePicker
            placeholderText="Enter To Date"
            selected={toDate}
            minDate={fromDate}
            onChange={handleToDate}
            format={"dd-MM-yyyy"}
          />
        </div>
      </div>
      <div className="failureReqTableContainer">
        <NormalTable headerDetails={headerDetails}>
          {tableDetails.length > 0
            ? tableDetails.map((list, index) => {
              return (
                <>
                  <tr className="border">
                    <td
                      style={{
                        paddingLeft: "18px",
                      }}
                    >
                      {(currentPage - 1) * 10 + (index + 1)}
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          gap: "3px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        {list?.user_name ? (
                          <div
                            style={{
                              height: "30px",
                              width: "30px",
                              backgroundColor: "#1E2156",
                              borderRadius: "50%",
                              color: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {getInitials(list?.user_name)}
                          </div>
                        ) : (
                          ""
                        )}
                        <p>{list?.user_name || "-"}</p>
                      </div>
                    </td>
                    <td>{list.country_code}&nbsp;{list.mobile_number}</td>
                    <td>{list.company_name}</td>
                    <td>
                      {moment(list.updatedAt).format("DD/MM/YYYY")}
                      {/* <span style={{ marginLeft: "3px" }}>
                          {moment(list.updatedAt).format("hh:mm a")}
                        </span> */}
                    </td>
                    <td
                      style={{
                        color: `${list.report_status === 1
                          ? "#E84F44"
                          : list.report_status === 2
                            ? "#0e183c"
                            : "#0EA11C"
                          }`,
                      }}
                    >
                      {list.report_status === 1
                        ? "Pending"
                        : list.report_status === 2
                          ? "Inprogress"
                          : "Sent"}
                    </td>
                    <td>
                      <button
                        onClick={() =>
                          navigate(
                            `/request/failureAnalysisRequestDetails/${list.remote_failure_details_id}`
                          )
                        }
                        className="failureRequestViewButton"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </>
              );
            })
            : " "}
        </NormalTable>
        {tableDetails.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh" }}>{isLoading ? "Loading" : "No Data Found"} </p>}
        {tableDetails.length > 0 ?
          <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          /> : " "}
      </div>
    </div>
  );
};

export default FailureAnalysisRequest;
